import firebase from 'firebase/compat/app';
import {
    getDocs,
    query,
    collection,
    where,
    QueryConstraint,
    setDoc,
    doc,
    updateDoc
} from "firebase/firestore";
import {Action, actionFromJson} from "../../models/action/action";
import {v4 as uuidv4} from 'uuid';
import {firestore, functions} from "../../firebase";
import {httpsCallable} from "firebase/functions";
import {randomBytes} from "crypto";
import {generateKey} from "../../utils/random";

export class ActionFirestore {


    async getActions(projectId: string) {
        try {
            const whereClauses: QueryConstraint[] = []
            whereClauses.push(where("projectId", "==", projectId), where("isDeleted", "==", false))
            const q = query(collection(firestore, "action"), ...whereClauses);

            const querySnapshot = await getDocs(q)
            const data: Action[] = []
            querySnapshot.docs.forEach(doc => {
                data.push(actionFromJson(doc.data()))
            })

            return {kind: "ok", data}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async addAction(formData: {
        name: string, amount: number, direction: string
    }, businessId: string, projectId: string) {
        try {
            const uuid = uuidv4();
            const millis = Date.now();
            const id = `${uuid}-${millis}`

            const actionData = {
                ...formData,
                actionKey: generateKey(),
                id,
                businessId,
                projectId,
                isDeleted: false,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await setDoc(doc(firestore, "action", id), actionData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async updateAction(id: string, formData: {
        name: string, amount: number, direction: string
    }) {
        try {

            const actionData = {
                ...formData,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "action", id), actionData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async revokeActionKey(id: string, newApiKey: string) {
        try {
            const actionData = {
                actionKey: newApiKey,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "action", id), actionData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async deleteAction(id: string) {
        try {
            const actionData = {
                isDeleted: true,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "action", id), actionData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }
}
